import { Badge } from '@octopus-do/octopus-storybook'
import type React from 'react'

export const CopywriterBadge: React.FC = () => {
  return <Badge type="copywriter" size="large" />
}
